import React, {FC} from "react"
import {get} from "lodash"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Product from "@irati/products/types/Product"
import {ReduxState} from "@irati/store/types"
import {connect} from "@irati/store"
import mainTheme from "@irati/ui/src/global/theme"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import getProductDetails from "@irati-web/platform/src/components/Header/utils/getProductDetails"

import {ProductCard, ProductContent, ProductLogo, ResponsiveBody, ResponsiveH3} from "./styled"
import TenantProductLink from "./TenantProductLink"

interface Props extends InjectIntl {
  id: string
  isLast: boolean
  isMobile: boolean
  isTablet: boolean
  product: Product
}

const TenantProduct: FC<Props> = ({formatMessage, isLast, product}) => {
  const productDetails = getProductDetails(formatMessage)
  const p = productDetails[product.product]
  if (!p) {
    return null
  }

  return (
    <TenantProductLink cardId={product.product} product={product} to="/" trackingName={product.trackingName}>
      <ProductCard isActive={product.active} isLast={isLast} id={product.product}>
        <ProductLogo backgroundColor={p.color}>
          <Icon color={mainTheme.colors.utility.white} icon={p.icon} size={32} />
        </ProductLogo>
        <ProductContent>
          <div>
            <ResponsiveH3>{p.title}</ResponsiveH3>
            <ResponsiveBody>{p.text}</ResponsiveBody>
          </div>
          <Icon icon={IconTypes.chevronRight} />
        </ProductContent>
      </ProductCard>
    </TenantProductLink>
  )
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: get(mq, "lessThan.medium", false),
  isTablet: get(mq, "lessThan.large", false)
})

export default injectIntl(connect(mapStateToProps)(TenantProduct))
